// src/services/instances/admin-config.ts
import apiClient from '@/services/api/apiClient';
import { ConfigResponseData } from '@/model';
import { updateConfigStorageReference } from '@/utils/config';
import { Md5 } from 'ts-md5';
import { buildApiUrl } from '../utils';
import {
  GetAdminApplicationComponentResponse,
  GetAppMenuButtonsResponse,
  GetCardResponse,
  GetHomeAreaFeaturesResponse,
  GetSMTPResponse,
  PutCardResponse,
} from '../response/admin-config';
import {
  PutAdminApplicationComponentRequest,
  PutAppMenuButtonRequest,
  PutConfigCardRequest,
  PutHomeAreaFeaturesRequest,
} from '../request/admin-config';
import { QueryParams } from '@/model/query-params';

export class AdminConfigService {
  static config() {
    const hostname = window.location.hostname;
    const hashID = Md5.hashStr(hostname);
    const url = buildApiUrl('/api/v1/admin-config/config/:id', { id: hashID });
    return apiClient.get<ConfigResponseData>(url);
  }

  static async setConfig() {
    const [err, data] = await this.config();
    if (err) {
      console.error(err);
      return;
    }
    updateConfigStorageReference(data);
  }

  static getCard() {
    const url = buildApiUrl('/api/v1/admin-config/card');
    return apiClient.get<GetCardResponse>(url, undefined);
  }

  static putCard(data: PutConfigCardRequest) {
    return apiClient.updateWithFile<PutCardResponse>(buildApiUrl('/api/v1/admin-config/card'), data);
  }

  static getSMTP() {
    const url = buildApiUrl('/api/v1/admin-config/smtp');
    return apiClient.get<GetSMTPResponse>(url, undefined);
  }

  static putSMTP(data: any) {
    return apiClient.update<void>(buildApiUrl('/api/v1/admin-config/smtp'), data);
  }

  static getAdminApplicationComponent() {
    const url = buildApiUrl('/api/v1/admin-config/application-component');
    return apiClient.get<GetAdminApplicationComponentResponse>(url, undefined);
  }

  static putAdminApplicationComponent(data: PutAdminApplicationComponentRequest) {
    const aaa = {
      component_id: data.component_id,
      active: data.active,
    };
    return apiClient.update<void>(buildApiUrl('/api/v1/admin-config/application-component'), aaa);
  }

  static getHomeAreaFeatures(params?: QueryParams) {
    return apiClient.get<GetHomeAreaFeaturesResponse>('/api/v1/admin-config/home-area-features', params);
  }

  static putHomeAreaFeatures(data: PutHomeAreaFeaturesRequest) {
    return apiClient.update<void>('/api/v1/admin-config/home-area-features', data);
  }

  static getAppMenuButtons(params?: QueryParams) {
    return apiClient.get<GetAppMenuButtonsResponse>('/api/v1/admin-config/app-menu-buttons', params);
  }

  static putAppMenuButtons(data: PutAppMenuButtonRequest) {
    return apiClient.update<void>('/api/v1/admin-config/app-menu-buttons', data);
  }
}
